// ----------------------------------------------------------------------
// <copyright file="Izenda.Font.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var FontFormat = require('share/components/controls/Izenda.FontFormat');
  var FontStyle = require('share/components/controls/Izenda.FontStyle');
  var ColorPicker = require('share/components/controls/Izenda.ColorPicker');
  var UIConstants = require('logic/data/Izenda.UIConstants');

  var Font = React.createClass({

    propTypes: {
      value: React.PropTypes.object,
      onChange: React.PropTypes.func,
      disabled: React.PropTypes.bool
    },

    getDefaultProps: function() {
      return {
        value: {
          style: {},
          format: {},
          color: UIConstants.textColor,          
          backgroundColor: UIConstants.textBackgrounColor
        },
        showBackgroundColor: true,
        disabled: false
      };
    },

    getInitialState: function() {
      var props = this.props;
      var value = props.value || {};
      return {
        style: value.style,
        format: value.format,
        color: value.color,
        backgroundColor: value.backgroundColor,
        disabled: props.disabled
      };
    },

    componentWillReceiveProps: function(nextProps) {
      var value = nextProps.value || {};
      this.setState({
        style: value.style,
        format: value.format,
        color: value.color,
        backgroundColor: value.backgroundColor,
        disabled: nextProps.disabled
      });
    },

    changeState: function(key, value) {
      var obj = {};
      obj[key] = value;
      this.setState(obj, function() {
        var props = this.props;
        props.onChange && props.onChange({value: this.state});
      }.bind(this));
    },

    render: function() {
      var state = this.state;
      var props = this.props;

      var handleFontFormatChanged = function(format) {
        this.changeState('format', format.value);
      }.bind(this);

      var handleFontStyleChanged = function(fontStyle) {
        this.changeState('style', fontStyle.value);
      }.bind(this);

      var handleColorChanged = function(color) {
        this.changeState('color', color);
      }.bind(this);

      var handleBackgroundChanged = function(color) {
        this.changeState('backgroundColor', color);
      }.bind(this);

      return (
          <fieldset className='font' disabled={state.disabled}>
            <FontFormat disabled={state.disabled} value={state.format} onChange={handleFontFormatChanged} />
            <div className='color-font-style'>
              <FontStyle value={state.style} border onChange={handleFontStyleChanged} className='u_floatLeft' />
              <ColorPicker iconName='icon-font'
                           color={state.color}
                           disabled={state.disabled}
                           onChange={handleColorChanged}
                           position={this.props.position} />
              {
              props.showBackgroundColor && <ColorPicker iconName='icon-font'
                           isHighlightControl={true}
                           color={state.backgroundColor}
                           disabled={state.disabled}
                           onChange={handleBackgroundChanged}
                           position={this.props.position}  />
              }
            </div>
          </fieldset>
      );
    }

  });

  module.exports = Font;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Font.jsx